// import "bootstrap/dist/css/bootstrap.min.css";
// import "./App.css";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import NavigationBar from "./components/Navbar";
// import Footer from "./components/Footer";
// import ScrollToTop from "./components/ScrollToTop";
// import Home from "./pages/Home";
// import Products from "./pages/Products";
// import Services from "./pages/Services";
// import About from "./pages/About";
// import Contact from "./pages/Contact";
// import FloatingButtons from "./components/FloatingButtons";

// function App() {
//   return (
//     <Router>
//       <ScrollToTop />
//       <div className="App">
//         <NavigationBar />
//         <main>
//           <Routes>
//             <Route path="/" element={<Home />} />
//             <Route path="/products" element={<Products />} />
//             <Route path="/services" element={<Services />} />
//             <Route path="/about" element={<About />} />
//             <Route path="/contact" element={<Contact />} />
//           </Routes>
//         </main>
//         <FloatingButtons />
//         <Footer />
//       </div>
//     </Router>
//   );
// }

// export default App;

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavigationBar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Material from "./pages/Material";
import FloatingButtons from "./components/FloatingButtons"; // Import FloatingButtons

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <NavigationBar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/services" element={<Services />} />
            <Route path="/material" element={<Material />}></Route>
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <FloatingButtons /> {/* This ensures buttons are always visible */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
